import { HTMLELEMENT } from '../../../EL/EL.js';
// import TABLE, { TableElementModel } from '@model/EL/table/TABLE.js';
import TGROUP from '../../../DOM/table/TGROUP/TGROUP.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const tfootAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const tfootData = makeDataStruct([]);
export const tfootModel = makeStruct([
    ['attributes', tfootAttr],
    ['data', tfootData]
]);
// Simplified Model
export function tfoot(name, className) {
    return {
        attributes: tfootAttr(name, className),
        data: tfootData()
    };
}
/** A TABLE Footer Group */
export default class TFOOT extends TGROUP {
    // declare public node: TABLE<TableElementModel>;
    // constructor(node: TABLE<TableElementModel>, model: M) {
    constructor(node, model) {
        super(node, HTMLELEMENT.TFOOT, model);
        this.addClass('table-footer');
    }
}
